import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-LG-logo_svg__Calque_1",
  viewBox: "0 0 13.28 13.28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-LG-logo_svg__cls-3{fill-rule:evenodd;fill:#0090b8}", -1)
        ]))]),
        _: 1
      })),
      _cache[1] || (_cache[1] = _createElementVNode("mask", {
        id: "svg-LG-logo_svg__mask",
        width: "76.82",
        height: "23.57",
        x: "0",
        y: "0",
        maskUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("g", { id: "svg-LG-logo_svg__d" }, [
          _createElementVNode("path", {
            id: "svg-LG-logo_svg__c",
            d: "M0 0h76.82v23.57H0",
            style: {"fill-rule":"evenodd","fill":"#fff"}
          })
        ])
      ], -1))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M7.87 1.45 1.77 8.8c-.06.07-.09.15-.06.22s.09.12.18.12h9.44c.08 0 .14-.07.14-.15s-.04-.13-.12-.15c-.34-.08-2.19-.48-3.53-.88C7 7.71 6.68 7 6.89 6.05 7.13 5 8.13 1.64 8.14 1.62c.02-.07 0-.15-.06-.19-.08-.04-.15-.02-.2.04",
      class: "svg-LG-logo_svg__cls-3"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M6.65.81A5.84 5.84 0 0 0 .81 6.65a5.835 5.835 0 0 0 5.95 5.73c3.14-.06 5.68-2.59 5.73-5.73 0-3.22-2.6-5.84-5.82-5.84h-.03M6.65 0c3.65 0 6.63 2.97 6.63 6.65s-2.98 6.63-6.63 6.63S0 10.3 0 6.65C0 2.98 2.97 0 6.65 0",
      class: "svg-LG-logo_svg__cls-3",
      style: {"mask":"url(#svg-LG-logo_svg__mask)"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LG-logo"}) } }